//Node Modules
import { useTranslation } from "react-i18next";
import { useRecoilValueLoadable } from "recoil";

//Pages

//BinaryForge Components
import { UserListTable } from "../../user";
import { Note } from "../../helpers";
import { DatatableSkeleton } from "../../helpers/skeleton";

//3rd Party Components

//Atoms
import { adminUsersSelector } from "../../../atoms/admin";

//Helpers

//Other

const UserList = () => {
	//Hooks
	const { t } = useTranslation();

	//Recoil
	const { state, contents } = useRecoilValueLoadable(adminUsersSelector);

	switch (state) {
		case "hasError":
			return (
				<Note
					messageKey={`Error: ${contents.message ? contents.message : contents}`}
					icon="pi-exclamation-circle fontColour-error"
				/>
			);
		case "loading":
			return (
				<DatatableSkeleton
					columns={[
						t("user.common.username"),
						t("user.common.fullname"),
						t("user.common.email"),
						t("user.common.role"),
						t("user.common.active"),
					]}
				/>
			);
		case "hasValue":
			return <UserListTable userData={contents} admin />;
		default:
			return null;
	}
};

export default UserList;
